import React from "react";

const CheckboxRenderer = (props) => {
  const { stopEditing } = props;
  stopEditing && stopEditing(); // To disable edit mode as editing is taken care by the cellRenderer

  const handleClick = (event) => {
    let checked = event.target.checked;
    let colId = props.column.colId;
    props.node.setDataValue(colId, checked ? "Yes" : "No");
  };

  return (
    <input
      type="checkbox"
      onClick={handleClick}
      checked={props.value === "Yes"}
    />
  );
};

export default CheckboxRenderer;
